export enum EImportanceVegetationBerge {
    Absente = 1,
    Eparse,
    Dense
}
